if (!customElements.get('related-products-scrollbar')) {
  customElements.define('related-products-scrollbar', class extends HTMLElement {
    connectedCallback() {
      this.initializeFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.grid = this.previousElementSibling;
        this.thumb = this.querySelector('.related-products__scroll-indicator-thumb');
        this.root = this.closest('.related-products');
        if (!this.grid?.classList.contains('product-grid') || !this.thumb || !this.root) return;

        this.scheduleUpdate = () => {
          if (this.updateFrame) return;
          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.updateIndicator();
          });
        };
        this.grid.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this.grid);
        }
        this.updateIndicator();
      });
    }

    updateIndicator() {
      if (!this.isConnected || !this.grid) return;
      const scrollRange = this.grid.scrollWidth - this.grid.clientWidth;
      const showIndicator = window.matchMedia('(max-width: 989px)').matches && scrollRange > 1;
      this.hidden = !showIndicator;
      this.root.classList.toggle('related-products--scroll-indicator', showIndicator);
      if (!showIndicator) return;

      const trackWidth = this.clientWidth;
      const thumbWidth = Math.min(trackWidth, Math.max(32, trackWidth * this.grid.clientWidth / this.grid.scrollWidth));
      const progress = Math.min(1, Math.max(0, this.grid.scrollLeft / scrollRange));
      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${(trackWidth - thumbWidth) * progress}px)`;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initializeFrame);
      cancelAnimationFrame(this.updateFrame);
      this.grid?.removeEventListener('scroll', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      this.resizeObserver?.disconnect();
      this.root?.classList.remove('related-products--scroll-indicator');
    }
  });
}
